import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

import { mediaUp, rem } from 'approot/shared/style';
import {
  spacing4,
  spacing8,
  spacing12,
  spacing16,
} from 'approot/shared/styles/spacing.style';
import {
  grey1,
  grey2,
  grey4,
  grey5,
  grey8,
  grey9,
  grey10,
  purple1,
} from 'approot/shared/styles/colours.style';
import {
  font14,
  fontSize16,
  fontSize18,
} from 'approot/shared/styles/typography.style';
import {
  borderRadius16,
  borderRadius8,
  standardFocusState,
} from 'approot/shared/styles/borders.style';
import { LAYOUT_HEADER_HEIGHT } from '../layout.styles';
import IconNavArrow from 'approot/shared/inline-svg/navigation/icon-nav-arrow';
import { Box } from 'approot/shared/styles/box.style';

export const NavArrowIndicator = styled(IconNavArrow)`
  margin-left: ${rem(spacing8)};
  stroke: ${grey8};
  stroke-width: 1.5;
  transition: transform 200ms ease;
`;

type NavLinkProps = {
  isFocussed?: boolean;
};

const baseNavLink = css<NavLinkProps>`
  background-color: ${grey1};
  border: none;
  border-radius: ${rem(borderRadius8)};
  color: ${grey8};
  font-size: ${rem(fontSize18)};
  margin: 0 0 0 ${rem(spacing4)};
  padding: ${rem(11)} ${rem(spacing16)};
  text-align: left;
  text-decoration: none;
  position: relative;

  ${standardFocusState}
  &:focus {
    background-color: ${grey2};
    color: ${grey10};
  }

  &:hover {
    cursor: pointer;
    color: ${grey10};
    background-color: ${grey2};
  }

  ${({ isFocussed }) =>
    isFocussed &&
    `
    color: ${grey10};
    ${NavArrowIndicator} {
      transform: rotate(180deg);
    }
  `}
`;

export const NavLinkStyled = styled(Link)<NavLinkProps>`
  ${baseNavLink}
`;

export const NavButtonStyled = styled.button<NavLinkProps>`
  ${baseNavLink}
`;

export const NavRoundButtonStyled = styled.button<NavLinkProps>`
  ${baseNavLink}
  border-radius: ${rem(40)};
  border: 1px solid ${grey5};
  height: ${rem(40)};
  margin-left: 0;
  padding: ${rem(spacing4)};
  padding-right: ${rem(spacing8)};
  display: flex;
  align-items: center;

  &:hover {
    background-color: ${grey2};
  }

  ${mediaUp.xl`
    padding: ${rem(spacing4)};
    padding-right: ${rem(spacing8)};
  `}
`;

export const NavDropdown = styled.div`
  background: ${grey1};
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  border-radius: ${rem(borderRadius16)};
  display: none;
  min-width: ${rem(160)};
  right: ${rem(spacing16)};
  position: fixed;
  top: ${rem(LAYOUT_HEADER_HEIGHT)};
  z-index: 100;

  ${NavLinkStyled}, ${NavButtonStyled} {
    display: flex;
    align-items: center;
    font-size: ${rem(fontSize16)};
    margin: 0;
    padding: ${rem(spacing12)};
    width: 100%;

    &:hover {
      background-color: ${purple1};
    }
    svg {
      margin-right: ${rem(spacing8)};
      stroke: ${grey9};
    }
  }
`;

export const NavDropdownSection = styled.div`
  padding: ${rem(spacing12)};
`;

type NavSecondaryProps = {
  activeSection?: string;
};
export const NavigationUserContainer = styled.nav<NavSecondaryProps>`
  & > ul,
  & > ul li {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  ${({ activeSection }) =>
    activeSection &&
    `
    #${activeSection} + ${NavDropdown} {
      display: block;
    }
  `}
`;

export const NavBreakStyled = styled.hr`
  border-top-color: ${grey4};
  margin: 0;
`;

export const NavCtas = styled(Box).attrs({
  $gap: spacing12,
})``;

export const NavUserButtonText = styled.span`
  ${font14}
  margin: 0 ${rem(spacing8)};
`;
